import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { I18n } from 'react-redux-i18n';

type ModalOverlayProps = {
  $open: boolean;
};

const ModalOverlay = styled.div<ModalOverlayProps>`
  display: ${(props) => (props.$open ? 'flex' : 'none')};
  position: fixed !important;
  animation: opacity 0.5s;
  z-index: 999999 !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  justify-content: center;
  align-items: center;
  pointer-events: ${(props) => (props.$open ? 'auto' : 'none')};

  .backFilter {
    background-color: ${(props) => props.theme.colors.dark};
    opacity: 0.5;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 999999;
    top: 0;
    left: 0;
  }

  .modalContainer {
    background-color: white;
    width: 500px;
    min-height: 250px;
    z-index: 1000000;
    position: relative;
    opacity: 1;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    @media (max-width: 845px) {
      width: 80vw;
      min-width: 0;
    }
  }

  .modalHeader {
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${(props) => props.theme.colors.dark};
    border-radius: 4px 4px 0 0;
  }

  .modalTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 18px;
    font-weight: 400;
    color: white;
    margin-left: 30px;
    text-transform: uppercase;
  }

  .modalContent {
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 190px;
  }

  .spinnerContainer {
    margin-bottom: 20px;
  }

  .messageText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 16px;
    color: ${(props) => props.theme.colors.dark};
    text-align: center;
    line-height: 1.5;
    max-width: 400px;
  }

  .warningText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    color: ${(props) => props.theme.colors['terra-cotta']};
    text-align: center;
    margin-top: 15px;
    font-weight: 500;
  }
`;

type DownloadPreparationModalProps = {
  open: boolean;
  message?: string;
  warningMessage?: string;
};

const DownloadPreparationModal = ({
  open,
  message,
  warningMessage
}: DownloadPreparationModalProps) => {
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 48, color: '#e25d34' }} spin />
  );

  if (!open) return null;

  const modalContent = (
    <ModalOverlay $open={open}>
      <div className="backFilter" />
      <div className="modalContainer">
        <div className="modalHeader">
          <h1 className="modalTitle">
            {I18n.t('downloadPreparation.title') || 'Download Preparation'}
          </h1>
        </div>
        <div className="modalContent">
          <div className="spinnerContainer">
            <Spin indicator={antIcon} />
          </div>
          <p className="messageText">
            {message ||
              I18n.t('downloadPreparation.message') ||
              'Your download is being prepared. Please wait...'}
          </p>
          <p className="warningText">
            {warningMessage ||
              I18n.t('downloadPreparation.warning') ||
              'Please do not close this page until the download starts.'}
          </p>
        </div>
      </div>
    </ModalOverlay>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default DownloadPreparationModal;
